import { Container } from '@/lib/classes/dependency-injector';
import NavigationService from '@/modules/navigation/services/navigation';
import VersionsServices from '@/modules/versioning/services/versions';

export const injectServices = () => {
	Container.set('navigation-service', new NavigationService());
	Container.set('versions-service', new VersionsServices());
};
